import { gql } from 'graphql-request';

export const CHECK_CERTIFICATES = gql`
  query CorePOAUsers($certificates: [String!]!, $poaId: String!) {
    corePOAUsers {
      checkCertificates(input: { certificates: $certificates, poaId: $poaId })
    }
  }
`;
